import Navbar from '@/components/smartpos/Navbar';
import Footer from '@/components/smartpos/Footer';
import FloatingCTA from '@/components/smartpos/FloatingCTA';
import TrustSection from '@/components/smartpos/TrustSection';
import GoogleReviews from '@/components/smartpos/GoogleReviews';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import { useLanguage } from '@/lib/LanguageContext';

const meta = {
  ES: { title: 'Casos de Éxito — SmartPOS', desc: 'Más de 500 negocios en España confían en SmartPOS. Descubre cómo hemos transformado hostelería, retail y belleza con nuestro ecosistema POS.' },
  EN: { title: 'Success Stories — SmartPOS', desc: 'Over 500 businesses in Spain trust SmartPOS. Discover how we have transformed hospitality, retail and beauty with our POS ecosystem.' },
  CA: { title: 'Casos d\'Èxit — SmartPOS', desc: 'Més de 500 negocis a Espanya confien en SmartPOS. Descobreix com hem transformat hostaleria, retail i bellesa amb el nostre ecosistema POS.' },
  FR: { title: 'Témoignages — SmartPOS', desc: 'Plus de 500 entreprises en Espagne font confiance à SmartPOS. Découvrez comment nous avons transformé l\'hôtellerie, le retail et la beauté avec notre écosystème POS.' },
};

export default function CasosExito() {
  const { lang } = useLanguage();
  const m = meta[lang] || meta.ES;
  useDocumentMeta({ title: m.title, description: m.desc, canonicalPath: '/casos-exito' });

  return (
    <div className="min-h-screen font-body bg-white">
      <Navbar />
      <main id="contenido-principal">
        <TrustSection />
        <GoogleReviews />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}